import React from 'react'
import ViewEmp from '../Components/Employee/ViewEmp/ViewEmp'

const ViewEmpPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
        <ViewEmp/>
    </div>
  )
}

export default ViewEmpPage
